import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"
import PaymentStateChip from "@/modules/Invoicing/components/PaymentStateChip.vue"
import { ConsultantInvoice, StaffingPositionDeliverable } from "@/gql"
import { useUtilities } from "@/hooks/useUtilities"
import ActivityTimeline from "@/components/widgets/timeline/ActivityTimeline.vue"
import useRouter from "@/router/useRouter"
import { ref } from "vue"
import { useTranslation } from "@/i18n/useTranslation"
import PrintableInvoice from "@/modules/Invoicing/components/PrintableInvoice.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultantInvoiceDetail',
  props: {
    invoice: null
  },
  setup(__props: any) {

const props = __props as {
  invoice: ConsultantInvoice
}

const { t } = useTranslation("Missions/Invoices")

const { formatDate } = useUtilities()

const { routes } = useRouter()



const invoiceDetails = [
  {
    label: t("billedTo"),
    value: props.invoice.missionLifecycle?.contractingEntity
      ?.toUpperCase()
      .replace("_", " ")
      .replace(/\b\w/g, (char) => char.toUpperCase()),
  },
  {
    label: t("from"),
    value: props.invoice.consultant.name,
  },
]

const getDeliverableStatus = (deliverable: StaffingPositionDeliverable) => {
  if (deliverable.completed) {
    return t("completed")
  }
  return t("pending")
}

const getTotal = (quantity: number, unitCost: number) => {
  return (quantity * unitCost).toFixed(2)
}
const printablePage = ref<InstanceType<typeof PrintableInvoice> | null>(null)
const isOpen = ref(false)

return { __sfc: true,t, formatDate, routes, props, invoiceDetails, getDeliverableStatus, getTotal, printablePage, isOpen, Icon, PaymentStateChip, ActivityTimeline, PrintableInvoice }
}

})